import { getDataMapper, mapField } from "@/shared";

export const mapLanguageToServer = getDataMapper({
    code: mapField("code"),
    title: mapField("title"),
    visible: mapField("visible"),
});
